import ContactsMap from "./ContactsMap";

export default ContactsMap;
